import Vue from 'vue';
import VCalendar from 'v-calendar';
import VueHead from 'vue-head';
import Avatar from 'vue-avatar';
import IconSvg from '@/components/IconSvg.vue';
import Box from '@/components/Layout/Box.vue';
import TheHeaderSecondRow from '@/components/Layout/TheHeaderSecondRow.vue';
import multiSelect from '@/components/Forms/VueMultiSelect.vue';
import VueEditor from '@/components/VueEditor.vue';
import VueProgressBar from 'vue-progressbar';
import InputHasIcon from '@/components/Forms/InputHasIcon.vue';
import bInputNumber from '@/components/Forms/bInputNumber.vue';
import bFormLabel from '@/components/Forms/bFormLabel.vue';
import '@/components/TheNotifications';
import VueFuse from 'vue-fuse';

import Alert from 'bootstrap-component/alert';
import Badge from 'bootstrap-component/badge';
import Button from 'bootstrap-component/button';
import ButtonGroup from 'bootstrap-component/button-group';
import ButtonToolbar from 'bootstrap-component/button-toolbar';
import InputGroup from 'bootstrap-component/input-group';
import Layout from 'bootstrap-component/layout';
import Dropdown from 'bootstrap-component/dropdown';
import Form from 'bootstrap-component/form';
import FormGroup from 'bootstrap-component/form-group';
import FormCheckbox from 'bootstrap-component/form-checkbox';
import FormRadio from 'bootstrap-component/form-radio';
import FormInput from 'bootstrap-component/form-input';
import FormTextarea from 'bootstrap-component/form-textarea';
import FormFile from 'bootstrap-component/form-file';
import FormSelect from 'bootstrap-component/form-select';
import ListGroup from 'bootstrap-component/list-group';
import Media from 'bootstrap-component/media';
import Modal from 'bootstrap-component/modal';
import Nav from 'bootstrap-component/nav';
import Pagination from 'bootstrap-component/pagination';
import PaginationNav from 'bootstrap-component/pagination-nav';
import Popover from 'bootstrap-component/popover';
import Progress from 'bootstrap-component/progress';
import Table from 'bootstrap-component/table';
import Tabs from 'bootstrap-component/tabs';
import Tooltip from 'bootstrap-component/tooltip';
import Spinner from 'bootstrap-vue/es/components/spinner';
import Vuelidate from 'vuelidate';
import VueMasonry from 'vue-masonry-css';
import config from './../../config/index';

const options = {
  color: config.progressbar.color,
  failedColor: config.progressbar.color,
  thickness: '1px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
};

export default function registerComponents() {
  Vue.use(Alert);
  Vue.use(Badge);
  Vue.use(Button);
  Vue.use(ButtonGroup);
  Vue.use(ButtonToolbar);
  Vue.use(InputGroup);
  Vue.use(Layout);
  Vue.use(Dropdown);
  Vue.use(Form);
  Vue.use(FormGroup);
  Vue.use(FormCheckbox);
  Vue.use(FormRadio);
  Vue.use(FormInput);
  Vue.use(FormTextarea);
  Vue.use(FormFile);
  Vue.use(FormSelect);
  Vue.use(ListGroup);
  Vue.use(Media);
  Vue.use(Modal);
  Vue.use(Nav);
  Vue.use(Pagination);
  Vue.use(PaginationNav);
  Vue.use(Popover);
  Vue.use(Progress);
  Vue.use(Table);
  Vue.use(Tabs);
  Vue.use(Tooltip);
  Vue.use(Spinner);
  Vue.use(VueProgressBar, options);
  Vue.use(VueHead, {
    separator: '-',
    complement: config.hostName
  });
  Vue.use(VCalendar, {
    locale: 'en-US',
    datePickerShowDayPopover: false,
    datePickerTintColor: config.datepicker.datePickerTintColor
  });
  Vue.use(Vuelidate);
  Vue.use(VueMasonry);
  Vue.use(VueFuse);
  Vue.component(Avatar);
  Vue.component('b-input-number', bInputNumber);
  Vue.component('b-form-label', bFormLabel);

  Vue.component('input-has-icon', InputHasIcon);
  Vue.component('multiSelect', multiSelect);
  Vue.component('vue-editor', VueEditor);
  Vue.component('svgIcon', IconSvg);
  Vue.component('box', Box);
  Vue.component('theHeaderSecondRow', TheHeaderSecondRow);
}
